import { useEffect, useState } from 'react';
import { ConnectDeviceOptions } from '../../../../dish.types';
import { DeviceFilterType } from '../../../../functions/devices.instance';
import BackgroundDishComponent from './components/background/background.dish.component';

interface ConfigurationSettings {
    connectDevice: (devices: { videoId: string } | { audioId: string } | { videoId: string, audioId: string }, options: ConnectDeviceOptions) => void;
    localScreams?: MediaStream[];

    getDevices: (filter?: DeviceFilterType) => Promise<MediaDeviceInfo[] | undefined>
}
interface HTMLInputEvent extends Event {
    target: HTMLInputElement & EventTarget;
}
export default function DishDevicesVideoAudioSelector({ connectDevice, localScreams, getDevices }: ConfigurationSettings) {

    const [videoDevices, setVideoDevices] = useState<MediaDeviceInfo[]>([])
    const [audioDevices, setAudioDevices] = useState<MediaDeviceInfo[]>([])
    const [videoSelected, setVideoSelected] = useState<string>()
    const [audioSelected, setAudioSelected] = useState<string>()
    const [backgroundImage, setBackgroundImage] = useState<string | undefined>(undefined)
    // record:
    const [recordToggle, setRecordToggle] = useState<boolean>(false)
    const [recordSelected, setRecordSelected] = useState<boolean>(false)
    // ptz
    const [ptzToggle, setPtzToggle] = useState<boolean>(false)
    const [ptzSelected, setPtzSelected] = useState<boolean>(false)
    // echo
    const [echoToggle, setEchoToggle] = useState<boolean>(false)
    const [echoSelected, setEchoSelected] = useState<boolean>(false)
    const [noiseToggle, setNoiseToggle] = useState<boolean>(false)
    const [noiseSelected, setNoiseSelected] = useState<boolean>(false)

    const [labelVideo, setLabelVideo] = useState<string>()
    const [labelAudio, setLabelAudio] = useState<string>()
    const [status, setStatus] = useState<boolean>(false)
    const [statusAudio, setStatusAudio] = useState<boolean>(false)

    const openSelectorVideo = async () => {

        if (!status) {

            setStatus(true)
            // get video devices
            const response = await getDevices({
                video: true
            });
            console.log(response)
            response && setVideoDevices(response)

        }
        else {

            setStatus(false)

        }

    }

    const openSelectorAudio = async () => {

        if (!statusAudio) {

            setStatusAudio(true)

            // get audio devices
            const responseAudio = await getDevices({
                audio: true
            });
            console.log(responseAudio)
            responseAudio && setAudioDevices(responseAudio)

        }
        else {

            setStatusAudio(false)

        }

    }

    const apps = [
        {
            name: 'Visual Code',
        }
    ]
    const option = (device: MediaDeviceInfo, index: number, setDeviceSel: (deviceId: string) => void, setLabelSelected: (label: string) => void) => {

        console.log('device', device)

        return <div className='choose' key={index} onClick={() => {

            setDeviceSel(device.deviceId)
            setLabelSelected(device.label)
            setStatus(false)
            setStatusAudio(false)

        }}>
            <b>{
                device.label
            }</b>

        </div>

    }

    return <>
        <div className='selector'>
            <div className='placeholder' onClick={() => {

                openSelectorVideo()

            }}>
                <i className='las la-video'></i>
                <span>{labelVideo ? labelVideo : 'Selecciona un canal video'}</span>
                <i className='las la-angle-down'></i>
            </div>
            {
                status && <div className='chooses'>
                    {
                        videoDevices.map((device, index) => option(device, index, setVideoSelected, setLabelVideo))
                    }
                </div>
            }

        </div>
        <div className='selector'>
            <div className='placeholder' onClick={() => {

                openSelectorAudio()

            }}>
                <i className='las la-microphone'></i>
                <span>{labelAudio ? labelAudio : 'Selecciona un canal audio'}</span>
                <i className='las la-angle-down'></i>
            </div>
            {
                statusAudio && <div className='chooses'>
                    {
                        audioDevices.map((device, index) => option(device, index, setAudioSelected, setLabelAudio))
                    }
                </div>
            }

        </div>
        <div className='selector'>
            <div className='placeholder' onClick={() => {

                setRecordToggle(!recordToggle)

            }}>
                <i className='las la-compact-disc'></i>
                Grabación {recordSelected ? 'activada' : 'desactivada'}
                <i className='las la-angle-down'></i>
            </div>
            {
                recordToggle && <div className='chooses'>
                    <div className='choose' onClick={() => {

                        setRecordToggle(!recordToggle)
                        setRecordSelected(true)

                    }}>
                        <b>Activar</b>
                    </div>
                    <div className='choose' onClick={() => {

                        setRecordToggle(!recordToggle)
                        setRecordSelected(false)

                    }}>
                        <b>Desactivar</b>
                    </div>
                </div>
            }
        </div>
        <div className='selector'>
            <div className='placeholder' onClick={() => {

                setPtzToggle(!ptzToggle)

            }}>
                <i className='las la-crosshairs'></i>
                PTZ {ptzSelected ? 'activado' : 'desactivado'}
                <i className='las la-angle-down'></i>
            </div>
            {
                ptzToggle && <div className='chooses'>
                    <div className='choose' onClick={() => {

                        setPtzToggle(!ptzToggle)
                        setPtzSelected(true)

                    }}>
                        <b>Activar</b>
                    </div>
                    <div className='choose' onClick={() => {

                        setPtzToggle(!ptzToggle)
                        setPtzSelected(false)

                    }}>
                        <b>Desactivar</b>
                    </div>
                </div>
            }
        </div>
        <BackgroundDishComponent setBackgroundSelected={setBackgroundImage} />
        <div className='selector'>
            <div className='placeholder' onClick={() => {

                setEchoToggle(!echoToggle)

            }}>
                <i className='las la-volume-up'></i>
                Sistema de eco {echoSelected ? 'activado' : 'desactivado'}
                <i className='las la-angle-down'></i>
            </div>
            {
                echoToggle && <div className='chooses'>
                    <div className='choose' onClick={() => {

                        setEchoToggle(!echoToggle)
                        setEchoSelected(true)

                    }}>
                        <b>Activar</b>
                    </div>
                    <div className='choose' onClick={() => {

                        setEchoToggle(!echoToggle)
                        setEchoSelected(false)

                    }}>
                        <b>Desactivar</b>
                    </div>
                </div>
            }
        </div>
        <div className='selector'>
            <div className='placeholder' onClick={() => {

                setNoiseToggle(!echoToggle)

            }}>
                <i className='las la-drum'></i>
                Supresión de Ruido {noiseSelected ? 'activado' : 'desactivado'}
                <i className='las la-angle-down'></i>
            </div>
            {
                noiseToggle && <div className='chooses'>
                    <div className='choose' onClick={() => {

                        setNoiseToggle(false)
                        setNoiseSelected(true)

                    }}>
                        <b>Activar</b>
                    </div>
                    <div className='choose' onClick={() => {

                        setNoiseToggle(false)
                        setNoiseSelected(false)

                    }}>
                        <b>Desactivar</b>
                    </div>
                </div>
            }
        </div>
        {videoSelected && audioSelected && <div className='submit' onClick={() => {

            videoSelected && audioSelected && connectDevice({
                videoId: videoSelected,
                audioId: audioSelected,
            }, {
                background: backgroundImage,
                record: recordSelected,
                echo: echoSelected,
                ptz: ptzSelected,
                noise: noiseSelected
            })

        }}>
            Añadir <i className='las la-arrow-right' />
        </div>}

    </>

}